import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useState } from 'react';

import { SkipAllowListsSection } from '@apps/web/components/settings/skip_allow_lists_section';
import { Button } from '@apps/web/components/ui/button';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/skip-allow-lists')({
    component: SkipAllowListsPage,
});

function SkipAllowListsPage() {
    const { organizationId, gates } = useSettingsGates();
    const [isBulkAddOpen, setIsBulkAddOpen] = useState(false);
    if (!gates.canManageOrgSettings) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }
    return (
        <SettingsPageShell
            title="Skip/ Allow List"
            description="Choose who Phoebe includes or skips in outreach."
            headerAction={
                <Button
                    type="button"
                    variant="outline"
                    onClick={() => setIsBulkAddOpen(true)}
                >
                    Add in bulk
                </Button>
            }
        >
            <SkipAllowListsSection
                organizationId={organizationId}
                visibleSections={[
                    'callouts',
                    'clock_reminders',
                    'shift_confirmations',
                ]}
                variant="embedded"
                bulkAddOpen={isBulkAddOpen}
                onBulkAddOpenChange={setIsBulkAddOpen}
            />
        </SettingsPageShell>
    );
}
